
import moment from 'moment';
import { momentLocalizer } from 'react-big-calendar';
import { useSelector } from 'react-redux';
import { SchoolSchedule } from '../../components/common/SchoolSchedule';
import { useGetSchoolSchedulesQuery, useGetStudentSchoolSchedulesQuery } from '../../hooks/useGetSchoolSchedulesQuery';
import { useGetTeacheIdByUserId } from '../../hooks/useGetTeacheIdByUserId';
import { RootState } from '../../redux/store';
import { useGetStudentClassesQuery } from '../../hooks/useGetStudentClassesQuery';
import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { Callout, Flex } from '@radix-ui/themes';
import { useForm } from 'react-hook-form';
import SelectComponent from '../../components/inputs/Select/SelectComponent';
import { Link } from 'react-router-dom';
import { routes } from '../../routes';

export const StudentSchoolSchedulePreview = () => {
  const { UserId } = useSelector((state: RootState) => state.login.userData)
  const { data: studentData } = useGetTeacheIdByUserId(UserId, { enabled: !!UserId });
  const { data: studentClasses, isLoading: isLoadingStudentClasses, isError: isErrorStudentClasses } = useGetStudentClassesQuery({ PageNumber: 1, PageSize: 100, IdStudent: studentData?.idStudent }, { enabled: !!studentData?.idStudent })

  const { control, setValue, getValues, formState: { errors } } = useForm<{ idClass: string }>({
    defaultValues: { idClass: '' },
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldUseNativeValidation: false,
  });
  const { data: schoolSchedules, status: statusSchoolSchedule, isLoading: isLoadingSchoolSchedules, isError: isErrorSchoolSchedules, refetch: refreshSchoolSchedule } = useGetStudentSchoolSchedulesQuery({ PageNumber: 1, PageSize: 400, IdClass: getValues('idClass')! }, { enabled: !!getValues('idClass') });
  const convertToCalendarEvents = () => {
    const currentDate = moment().startOf('week');
    return schoolSchedules?.items.map(schedule => {
      const dayIndex = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday',]
        .indexOf(schedule.dayOfTheWeek);
      schedule.description = `${schedule.subject} | ${schedule.teacher} | ${schedule.classroom}`;
      const [startHour, startMinute] = schedule.startTime.split(':').map(Number);
      const [endHour, endMinute] = schedule.endTime.split(':').map(Number);

      const startDate = moment(currentDate)
        .add(dayIndex, 'days')
        .set('hour', startHour)
        .set('minute', startMinute)
        .toDate();

      const endDate = moment(currentDate)
        .add(dayIndex, 'days')
        .set('hour', endHour)
        .set('minute', endMinute)
        .toDate();

      return {
        title: schedule.description || "Sem descrição",
        start: startDate,
        end: endDate,
        allDay: false,
      };
    });
  };
  const handleClassChange = (idClass: string) => {
    setValue('idClass', idClass);
    refreshSchoolSchedule();
  }
  const events = convertToCalendarEvents();

  if (!studentData || !studentData.idStudent) {
    return (
      <Flex direction="column">
        <Callout.Root color="red" role="alert">
          <Callout.Icon>
            <ExclamationTriangleIcon />
          </Callout.Icon>
          <Callout.Text>
            Entre como estudante.{' '}
            <Link to={routes.dashboard} style={{ color: 'var(--gray-12)' }}>Voltar</Link>
          </Callout.Text>
        </Callout.Root>

      </Flex>
    );
  }
  return (
    <>
      <Flex direction='column' gap='4'>
        <SelectComponent
          label="Turma"
          options={studentClasses?.items.map((sc) => ({
            value: sc.idClass,
            label: sc.class ?? ""
          }))}
          errors={errors}
          control={control}
          itemsError={isErrorStudentClasses}
          itemsLoading={isLoadingStudentClasses}
          name={"idClass"}
          onSelect={handleClassChange}
        />
        <SchoolSchedule events={events} />
      </Flex>
    </>
  );
}
